import Event from '@oppobrowser/lib-browser-event';
import EventEmit from '@oppobrowser/lib-browser-eventEmit';
import template from './index.dot';
import { $, $$, showToast } from '@js/utils';
import { creatSingleAnimation, playPraiseAnimation } from '../../js/utils';
import Feedback from '../../js/feedback.js';
import './index.scss';

import { articlethumbup, articlethumbupThird } from '../../js/api';
let isShareHide = true;
const EventHandler = {
  toPraise(node, event) {
    event.stopPropagation();
    const container =
      this._container || (this._container = $('#praise_icon', node));
    container.classList.remove('share-praise__icon', 'share-praised__icon');
    // container.innerHTML=''
    const { isThumbUp, uid, feedssession } = window.store;
    isShareHide = false;
    (!this._animation || this._forceUpdate) &&
      (this._animation = this.initAnimation(container));

    this._forceUpdate = false; //获取实例后将强制更新标志false，在没又切换暗色模式的情况下可以使用之前的实例
    playPraiseAnimation(this._animation, !isThumbUp);
    let handler;
    const pageType = process.env.OFET_PAGE_TYPE;
    switch (pageType) {
      case 'feednewsThird':
        handler = articlethumbupThird;
        break;
      default:
        handler = articlethumbup;
    }
    const params = {
      operation: isThumbUp ? 'up' : 'cancel_up',
      userId: uid,
      feedssession,
    };
    handler(params).catch((error) => {
      throw error;
    });
    window.store.thumbUp();
  },

  shareToWeChatFriends(node, event) {
    event.stopPropagation();
    if (navigator.onLine) {
      window.wv.shareToWeChatFriends(this.shareContent);
    } else {
      showToast('网络连接不可用，请稍后重试');
    }
  },

  shareToWeChatMoment(node, event) {
    event.stopPropagation();
    if (navigator.onLine) {
      window.wv.shareToWeChatMoment(this.shareContent);
    } else {
      showToast('网络连接不可用，请稍后重试');
    }
  },
};

export default class Share {
  constructor(el, name, data = {}) {
    this.el = el;
    const { title, description } = window.store;
    this.shareContent = {
      title: title,
      desc: description,
      link: window.location.href,
      imgUrl: '',
    };
    this._eventHandler = {};
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
    this.setImgUrl();
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  initAnimation(container) {
    console.log('share night mode changed');
    const praseTextEl =
      this._praseTextEl || (this._praseTextEl = $('.praise-txt', this.el));
    const animation = creatSingleAnimation(
      container,
      document.documentElement.dataset.theme,
      { forceUpdate: this._forceUpdate },
    );
    animation.addEventListener('complete', function () {
      praseTextEl.innerHTML = window.store.upsCount || '赞';
    });
    return animation;
  }

  setImgUrl() {
    let imgUrl = '';
    const docInfo = window.pageData.DOCINFO || {};
    if (docInfo.pics && docInfo.pics.length) {
      imgUrl = docInfo.pics[0].smallPicUrl;
    } else {
      const defaultImgUrl =
        'https://dhfs.heytapimage.com/userfiles/images/browser.png';
      const $div = $('.entry-content');
      const $img = $div.getElementsByTagName('img');
      imgUrl = $img.length ? $img[0].src : defaultImgUrl;
    }
    this.shareContent.imgUrl = imgUrl;
  }

  // 夜间模式监听
  registerNightModeHandler() {
    // this._nightModeHandler();
    window.document.addEventListener('nightmodechange', () => {
      this._nightModeHandler();
    });
  }

  _nightModeHandler() {
    console.log('_nightModeHandler');
    if (this._container) {
      this._container.innerHTML = '';
      this._container.classList.add(
        window.store.isThumbUp ? 'share-praised__icon' : 'share-praise__icon',
      );
      // 用作获取单例animation时候判定是否更新单例中的实例
      this._forceUpdate = true;
      // 通过宏任务，让更新lottie，在SET_THEME的nightmodechange事件之后执行
      // setTimeout(() => {
      //   this._animation = this.initAnimation(this._container,true);
      // }, 0);
    }
  }

  renderEl({ upsCount, isThumbUp }) {
    this.el.innerHTML = template({
      upsCount: upsCount,
      className: isThumbUp ? 'share-praised__icon' : 'share-praise__icon',
      showClass:
        !window.store.isShowFold.isShow || !isShareHide ? '' : 'showClass',
    });
    this.registerNightModeHandler();
  }

  render() {
    this.renderEl(window.store);
    const btns = $$('.share-item', $('share-block '));
    btns.map((el) => new Feedback(el));
    EventEmit.instance.emit('component-loaded', 'share', {});
  }
}
